import App from 'app/app.js';

function LtLookLoaderDirective(IrisService, LooksStore, $filter, ContentStore, SubjectStore) {
  const placeholderCache = {};
  const preloadedImages = {};
  const orientations = LooksStore.getOrientations();

  orientations.forEach((orientation) => {
    const img = new Image();
    const src = `assets/images/loading/${orientation}_loading_error_large.jpg`;
    img.crossOrigin = 'anonymous';

    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        placeholderCache[orientation] = canvas.toDataURL('image/jpeg', 0.9);
      } catch (e) {
        placeholderCache[orientation] = src;
      }
    };

    img.onerror = () => {
      placeholderCache[orientation] = src;
    };

    img.src = src;
    preloadedImages[orientation] = img;
  });

  return {
    link(scope, element, attrs) {
      // Opt into the global right-click/drag deterrent (utils/image-protection.ts).
      element.attr('data-protected-image', '');

      const unwatch = scope.$watch(attrs.ltLookLoader, (look) => {
        let location;
        let bearerTokenURL;
        let orientation;
        let loadingClass;
        let errorClass;
        const isDSSK = attrs.ltLookLoaderType === 'dssk';
        const isDID = attrs.ltLookLoaderType === 'did';
        const studentIdFoundMatch = attrs.ltLookLoaderType === 'studentIdFoundMatch';
        const myDashboard = attrs.ltLookLoaderType === 'myDashboard';
        const confirmExistingStudent = attrs.ltLookLoaderType === 'confirmExistingStudent';

        if (!look) {
          return;
        }

        if (isDSSK || isDID || studentIdFoundMatch || myDashboard || confirmExistingStudent) {
          location = look.viewURL;
          bearerTokenURL = look?.bearerTokenURL;
        } else {
          location = LooksStore.getPreviewImageLocation(look);
          bearerTokenURL = look?.bearerTokenURL || SubjectStore.getSelectedSubject()?.bearerTokenURL;
        }

        if (!look.orientation) {
          look.orientation = isDSSK ? 'LANDSCAPE' : 'PORTRAIT';
        }

        orientation = look.orientation.toLowerCase();
        loadingClass = `image-loader-loading-${orientation}`;
        errorClass = `image-loader-error-${orientation}`;
        element.css('text-indent', '100%');

        if (!location) {
          element.addClass(errorClass);
          return;
        }

        // remove any previous error classes
        element.removeClass('image-loader-error-portrait');
        element.removeClass('image-loader-error-landscape');

        const toggleImageLoaderLoadingClass = (value) => {
          element.toggleClass(loadingClass, value);
        };

        const onError = () => {
          toggleImageLoaderLoadingClass(false);
          element.removeAttr('src');
          if (studentIdFoundMatch) {
            element.attr('src', 'assets/images/silhouette-no-image.svg');
            element.next().html($filter('ltTranslateFilter')('IMG_NOT_YET_AVAILABLE_DISCLAIMER'));
          } else {
            const elementWidth = element.width();
            const elementHeight = element.height();
            if (elementWidth && elementHeight) {
              const cachedPlaceholder = placeholderCache[look.orientation.toUpperCase()];
              element.attr(
                'src',
                cachedPlaceholder || `assets/images/loading/${look.orientation.toUpperCase()}_loading_error_large.jpg`
              );
            } else {
              element.addClass(errorClass);
            }
          }

          scope.$emit('error-event', false);
          element.unbind('error', onError);
        };

        element.on('$destroy', () => {});

        element.bind('error', onError);

        element.bind('load', () => {
          toggleImageLoaderLoadingClass(false);
        });

        element.removeAttr('src');
        toggleImageLoaderLoadingClass(true);
        if (location.indexOf('http') === 0) {
          const attr = attrs || '';
          IrisService.load(location, bearerTokenURL, attr)
            .then((imageUrl) => {
              element.attr('src', imageUrl);
              element.parent().addClass('white-background');
            })
            .catch(() => {
              onError();
            });
        } else {
          const separator = location.indexOf('/') === 0 ? '' : '/';
          element.attr('src', ContentStore.resolveContentImagePath(`${separator}${location}`));
          element.parent().addClass('white-background');
        }
      });

      scope.$onDestroy = () => {
        unwatch();
      };
    }
  };
}

App.directive('ltLookLoader', [
  'IrisService',
  'LooksStore',
  '$filter',
  'ContentStore',
  'SubjectStore',
  LtLookLoaderDirective
]);
